module.exports = __webpack_public_path__ + "static/media/cover.6f097ab4.jpg";